import { ICommande } from "./Commande.model";
import { IProduit } from "./Produit.model";

export interface IDetailCommande {
  id?: number;
  qte?: number;
  commentaire?: string;
  commande?: ICommande;
  produit?: IProduit;
}

export class DetailCommande implements IDetailCommande {
  constructor(
    public id?: number,
    public qte?: number,
    public commentaire?: string,
    public commande?: ICommande,
    public produit?: IProduit
  ) {}
}
